<template>
  <div class="flex items-center relative">
    <button
      ref="trigger"
      class="rounded-full shadow-2xl border-primary border p-0.5"
      aria-label="Optionen für Barrierefreiheit"
      @click="showSwitch = !showSwitch"
    >
      <AccessabilityIcon
        class="text-primary"
        :class="iconClasses"
      />
    </button>

    <div
      v-if="showSwitch"
      ref="popover"
      class="z-10 bg-stone-100 border-stone-400 border-2 text-black shadow-2xl font-bold select-none absolute p-8 top-1/2 flex gap-4 -translate-y-1/2"
      :class="'flyout-pos-' + position"
    >
      <div
        class="flex gap-4 cursor-pointer items-center"
        @click="useContrastMode(!contrastMode)"
      >
        Kontrastmodus <AnimationToggleSwitch :class="contrastMode ? 'active' : ''" />
      </div>
      <div
        class="absolute top-2 right-2 text-center cursor-pointer"
        @click.prevent="showSwitch = false"
      >
        <BasicIcon
          :name="'xmark-solid'"
          class="w-4 close-img"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';
import { useContrastMode } from '~/composables/states';

defineProps({
  iconClasses: {
    type: String,
    default: 'h-5 w-5',
  },
  position: {
    type: String,
    default: 'left',
  },
});

const showSwitch = ref(false);
const contrastMode = useContrastMode();

const triggerRef = useTemplateRef<HTMLElement>('trigger');
const popoverRef = useTemplateRef<HTMLElement>('popover');

onClickOutside(
  popoverRef,
  () => {
    showSwitch.value = false;
  },
  { ignore: [triggerRef] },
);
</script>
<style lang="postcss">
.flyout-pos-left {
  @apply right-full -translate-x-4;
}
.flyout-pos-right {
  @apply left-full translate-x-4;
}
.flyout-pos-down {
  @apply top-full translate-y-4 -translate-x-1/2;
}
</style>
